<template>
  <div v-if="transaction">
    <campaign-details :data-campaign.sync="transaction.campaign" />
    <user-details
      :data-user="transaction.referrer_user"
      title="Referrer"
      hide-actions
    />
    <customer-rewards-details title="Referrer Reward Details" :dataTransaction="transaction.referrer_reward" class="mt-5" />
    <blockchain-transaction :transaction="transaction.referrer_reward" />
    <user-details
      :data-user="transaction.referred_user"
      title="Referred User"
      class="mt-5"
      hide-actions
    />
    <customer-rewards-details title="Referred Reward Details" :dataTransaction="transaction.referred_reward" class="mt-5" />
    <blockchain-transaction :transaction="transaction.referred_reward" />
  </div>
</template>
<script>
import UserDetails from "@/app/users/detail";
import CampaignDetails from "@/app/campaigns/detail";
import CustomerRewardsDetails from "./details";
import BlockchainTransaction from "../../transfers/blockchaintransactions.vue";

export default {
  components: { UserDetails, CustomerRewardsDetails, BlockchainTransaction, CampaignDetails },
  props: {
    id: { required: true },
  },
  data: () => ({
    transaction: undefined,
  }),

  created() {
    this.$http
      .get(`api/v1/transactions/campaignReferrals/${this.id}`)
      .then((data) => {
        this.transaction = data;
      })
      .catch(() =>
        window.Notify.warning("Something went wrong while fetching customer reward details"),
      );
  },
};
</script>
